<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "MainT",
    }
</script>

<style scoped>

</style>